import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { RouterLink } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { disableDebugTools } from '@angular/platform-browser';

@Component({
  selector: 'app-table-list-caption',
  standalone: true,
  imports: [
    ButtonModule,
    InputTextModule,
    PaginatorModule,
    RouterLink,
    CalendarModule,
    TooltipModule,
    NgClass,
  ],
  templateUrl: './table-list-caption.component.html',
  styleUrl: './table-list-caption.component.scss',
})
export class TableCaptionComponent {
  readonly activeUserStore = inject(ActiveUserStore);

  @Input() searchWord = '';
  @Input() showRangeFilter = false;
  @Input() fromDate: Date | null = null;
  @Input() toDate: Date | null = null;
  @Input() quickLink: any | null = null;
  @Input() quickLinkLabel: string | null = null;
  @Input() addRoute: any[] = [{ outlets: { bearbeiten: 'neu' } }];
  @Input() disableAddButton = false;

  @Output() addItem = new EventEmitter<void>();
  @Output() clearTable = new EventEmitter<void>();
  @Output() search = new EventEmitter<string>();
  @Output() fromDateChange = new EventEmitter<Date | null>();
  @Output() toDateChange = new EventEmitter<Date | null>();

  /**
   * Retrieves the target as an HTMLInputElement from the provided EventTarget.
   *
   * @param {EventTarget | null} target - The event target to be cast as an HTMLInputElement.
   * @return {HTMLInputElement} The event target cast as an HTMLInputElement.
   */
  getTarget(target: EventTarget | null): HTMLInputElement {
    return target as HTMLInputElement;
  }

  /**
   * Emits the current date range by triggering the `fromDateChange` and `toDateChange` events.
   * @return {void} Does not return any value.
   */
  emitDateRange(): void {
    this.fromDateChange.emit(this.fromDate);
    this.toDateChange.emit(this.toDate);
  }

  /**
   * Clears the current state by resetting associated properties and emitting an event to notify the changes.
   *
   * @return {void} No return value.
   */
  clear(): void {
    this.fromDate = null;
    this.toDate = null;
    this.searchWord = '';
    this.clearTable.emit();
  }

  protected readonly disableDebugTools = disableDebugTools;
}
